import { observable, action, computed } from 'mobx';
import { fromPromise, IPromiseBasedObservable } from 'mobx-utils';
import { RootStore } from './index';
import { getNotificationEventsReport } from '../api/reportApi';

class ReportStore {
  rootStore : RootStore;

  @observable customerCode = 0;
  @observable notificationType = '';
  @observable startDate = '';
  @observable endDate = '';
  @observable events = [];
  @observable notificationEventsRequest : IPromiseBasedObservable<any> | null = null;

  constructor(rootStore : RootStore) {
    this.rootStore = rootStore;
  }

  @computed
  get customers() {
    return this.rootStore.configurationStore.customers;
  }

  @computed
  get notificationTypes() {
    return this.rootStore.configurationStore.notificationTypes;
  }

  @computed
  get notificationEvents() {
    if (this.notificationEventsRequest === null || this.notificationEventsRequest.state !== 'fulfilled')
      return {
        dayBreakdown: {},
        bounceReasons: [],
        clicks: [],
        clickGroups: []
      };

    return this.notificationEventsRequest.value;
  }

  @action.bound
  generateReport() {
    this.notificationEventsRequest = fromPromise(getNotificationEventsReport(this.customerCode, this.notificationType, this.startDate, this.endDate));
  }

  @action.bound
  setStartDate(startDate : string) {
    this.startDate = startDate;
  }

  @action.bound
  setEndDate(endDate : string) {
    this.endDate = endDate;
  }

  @action.bound
  getCustomers() {
    this.rootStore.configurationStore.getCustomers();
  }

  @action.bound
  setCustomerCode(customerCode : number) {
    this.customerCode = customerCode;
  }

  @action.bound
  getNotificationTypes() {
    this.rootStore.configurationStore.getNotificationTypes();
  }

  @action.bound
  setNotificationType(notificationType : string) {
    this.notificationType = notificationType;
  }
}

export default ReportStore;